import React from "react"
import Router from "./Router"
import "react-perfect-scrollbar/dist/css/styles.css"
import "slick-carousel/slick/slick.css"
import "prismjs/themes/prism-tomorrow.css"

const App = props => {
    return <Router/>
}

export default App
